import {nextTick, onMounted, reactive, unref, watch} from "vue";
import useDatasHooks from "@/main-page/ctls/hooks/useDatasHooks";
import useWatchHooks from "@/gateway-main/components/hooks/useWatchHooks";


export function useDataDealHooks({dataConfig, borderConfig, showFlag}) {
  const tableDs = ref([]);
  /**
   * 数据查询相关
   */
  const {
    initCtlData,
  }: any = useDatasHooks({dataConfig});


  const state = reactive({loadingFlag: true});
  const showCols = unref(dataConfig)["showCols"];

  /**
   *
   */
  const initCtlDataFun = () => {
    initCtlData(({res}) => {
      if (res) {
        const {total, records} = res;
        if (records) {
          tableDs.value = records;
        } else {
          if (res && Array.isArray(res)) {
            tableDs.value = res;
          }
        }
      }
      state.loadingFlag = false;
    })
    setTimeout(() => {
      state.loadingFlag = false;
    }, 500)
  }

  onMounted(() => {
    initCtlDataFun();
  })

  //监听变化
  useWatchHooks({initCtlData: initCtlDataFun, borderConfig, dataConfig, showFlag, loadingFlag: state.loadingFlag});
  if (window.appObj.isDes) {
    watch(unref(dataConfig)["showCols"], (newVal) => {
      initCtlDataFun && initCtlDataFun();
    })
  }

  const flushChart = () => {
    state.loadingFlag = true;
    nextTick(() => {
      initCtlDataFun && initCtlDataFun();
    })
  }

  return {
    tableDs,
    flushChart,
    showCols,
    state,
    initCtlDataFun
  }
}
